var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.75C7.75732 6.75 6.75 7.75732 6.75 9C6.75 10.2427 7.75732 11.25 9 11.25C10.2427 11.25 11.25 10.2427 11.25 9C11.25 7.75732 10.2427 6.75 9 6.75ZM8.25 9C8.25 8.58578 8.58578 8.25 9 8.25C9.41423 8.25 9.75 8.58578 9.75 9C9.75 9.41423 9.41423 9.75 9 9.75C8.58578 9.75 8.25 9.41423 8.25 9Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3725 8.46052C14.6565 5.36389 11.8591 3.75 9 3.75C6.14083 3.75 3.34347 5.36389 1.62752 8.46052C1.45978 8.7633 1.45771 9.13657 1.62022 9.4407C3.30887 12.601 6.1221 14.25 9 14.25C11.8779 14.25 14.6911 12.601 16.3798 9.4407C16.5423 9.13657 16.5402 8.7633 16.3725 8.46052ZM9 12.75C6.79573 12.75 4.53039 11.5293 3.0688 8.96152C4.55147 6.4471 6.80489 5.25 9 5.25C11.1951 5.25 13.4485 6.4471 14.9312 8.96152C13.4696 11.5293 11.2043 12.75 9 12.75Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.ecd4e4ea0fcd88ee75cee1d3b3485cc9.svg";
export { ForwardRef as ReactComponent };